import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api, formatApiError } from "../lib/api";
import { useAuth } from "../contexts/AuthContext";
import { toast } from "sonner";

export default function AuthCallback() {
  const nav = useNavigate();
  const { setUser } = useAuth();
  const handled = useRef(false);

  useEffect(() => {
    if (handled.current) return;
    handled.current = true;
    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    const session_id = m ? decodeURIComponent(m[1]) : null;

    (async () => {
      if (!session_id) {
        nav("/login", { replace: true });
        return;
      }
      try {
        const { data } = await api.post("/auth/google-session", { session_id });
        setUser(data);
        // clean URL
        window.history.replaceState({}, "", "/dashboard");
        toast.success(`Benvenuto, ${data.name}!`);
        nav("/dashboard", { replace: true });
      } catch (e) {
        toast.error(formatApiError(e) || "Errore login Google");
        nav("/login", { replace: true });
      }
    })();
  }, [nav, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-black">
      <div className="font-display tracking-[0.4em] text-zinc-400 uppercase text-sm">Autenticazione in corso…</div>
    </div>
  );
}
